
const initHeaderLanguage = () => {
  const dropdownItems = document.querySelectorAll('.wpml-ls-menu-item.menu-item-has-children, .wpml-ls-menu-item');
  const menuPrimary = document.querySelector('#menu-menu-primary');
  const menuPrimaryPT = document.querySelector('#menu-menu-primary-pt');
  const menuPrimaryCS = document.querySelector('#menu-menu-primary-cs');
  const menuPrimaryMobile = document.querySelector('#menu-menu-primary-1');

  const helpLink = '<button uk-toggle="target: #help-modal">Help</button>';
  const helpLinkPT = '<button uk-toggle="target: #help-modal">Ajuda</button>';
  const helpLinkCS = '<button uk-toggle="target: #help-modal">帮助</button>';

  if (menuPrimary) {
    menuPrimary.insertAdjacentHTML('beforeend', helpLink);
  }
  if (menuPrimaryPT) {
    menuPrimaryPT.insertAdjacentHTML('beforeend', helpLinkPT);
  }
  if (menuPrimaryCS) {
    menuPrimaryCS.insertAdjacentHTML('beforeend', helpLinkCS);
  }
  
  if (menuPrimaryMobile) {
    const lastItem = menuPrimaryMobile.querySelector('.wpml-ls-menu-item');

    if (lastItem) {
      lastItem.insertAdjacentHTML('beforebegin', helpLink);
    } else {
      menuPrimaryMobile.insertAdjacentHTML('beforeend', helpLink);
    }
  }

  dropdownItems.forEach(function (item) {
    const toggle = item.querySelector(':scope > a.dropdown-toggle');
    const menu = item.querySelector(':scope > .dropdown-menu');

    if (!toggle || !menu) {
      return;
    }

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const isOpen = item.classList.contains('is-open');

      dropdownItems.forEach(function (otherItem) {
        otherItem.classList.remove('is-open');

        const otherToggle = otherItem.querySelector(':scope > a.dropdown-toggle');
        if (otherToggle) {
          otherToggle.setAttribute('aria-expanded', 'false');
        }
      });

      if (!isOpen) {
        item.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
      } else {
        item.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  });

  document.addEventListener('click', function () {
    dropdownItems.forEach(function (item) {
      item.classList.remove('is-open');

      const toggle = item.querySelector(':scope > a.dropdown-toggle');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  });

  document.querySelectorAll('.wpml-ls-menu-item .dropdown-menu').forEach(function (menu) {
    menu.addEventListener('click', function (e) {
      e.stopPropagation();
    });
  });
};

document.addEventListener("DOMContentLoaded", function () {

  const languageItems = document.querySelectorAll('.wpml-ls-menu-item');

  languageItems.forEach(function (item) {

    const nativeSpan = item.querySelector('.wpml-ls-native');
    if (!nativeSpan) return;

    const lang = nativeSpan.getAttribute('lang');

    let shortText = '';

    if (lang === 'en') {
      shortText = 'EN';
    } else if (lang === 'pt-br') {
      shortText = 'PT';
    } else if (lang === 'zh-hans') {
      shortText = '中文';
    }

    nativeSpan.textContent = shortText;

    const displaySpan = item.querySelector('.wpml-ls-display');
    if (displaySpan) {
      displaySpan.remove();
    }

  });

});
document.querySelectorAll('.menu-item-has-children > a').forEach(function(link) {

    const carets = link.querySelectorAll('.caret');

    if (carets.length > 1) {
        carets.forEach((caret, index) => {
            if (index > 0) caret.remove(); // keep only first
        });
    }

});

export default initHeaderLanguage;
